module.exports = __webpack_public_path__ + "img/success.d511efbb.svg";